import { render } from "./TkCaseNotesHistoryPanel.vue?vue&type=template&id=2483e6c4&scoped=true"
import script from "./TkCaseNotesHistoryPanel.vue?vue&type=script&lang=js"
export * from "./TkCaseNotesHistoryPanel.vue?vue&type=script&lang=js"

import "./TkCaseNotesHistoryPanel.vue?vue&type=style&index=0&id=2483e6c4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2483e6c4"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QInput,QIcon,QSelect,QCheckbox,QInnerLoading,QField});
